const INVITATION_TARGETS = {
  mobile: 'mobile-app',
  commandCenter: 'command-center',
}

module.exports = { INVITATION_TARGETS }
